import { MuiComponent } from "./type";
import * as Colors from "../colors";

export const MuiChip: MuiComponent<"MuiChip"> = {
  variants: [
    {
      props: { color: 'success' },
      style: { backgroundColor: Colors.Green },
    },
    {
      props: { color: 'warning' },
      style: { backgroundColor: Colors.Yellow },
    },
    {
      props: { color: 'error' },
      style: { backgroundColor: Colors.Red },
    },
  ],
};